const OptionEl: HTMLOptionElement = new Option();

export const isValidCssColor = (input: string): boolean => {
	const s = OptionEl.style;
	s.color = ""; // Reset the color
	s.color = input; // Attempt to set it to the input string
	return s.color !== "";
};
